import { gsap } from "gsap"
import { ScrollToPlugin } from "gsap/ScrollToPlugin"
import utilities from '@/scripts/common/utilities'
import settings from "@/scripts/common/settings"
gsap.registerPlugin(ScrollToPlugin)
import { refreshAllControllers } from "@/scripts/common/api/scrolltrigger.services"

export const Carousels = (() => {
    class SlickCarousel {
        constructor(container, options) {
            this.$slider = container
            this.$slides = this.$slider.querySelectorAll('[class*="__item"]')
            this.$pagination = null
            this.arrowModifiers = null
            this.asNavFor = container.dataset.asNav || null
            this.goToPanel = !!container.dataset.gotoPanel || false
            this.isMobile = window.innerWidth < settings.breakpoints.mobile
            this.syncLocation = !!container.dataset.syncLocation || false
            const isRtl = document.documentElement.getAttribute('dir') === 'rtl'

            this.options = Object.assign({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                pauseVideoOnCurrent: "1",
                dots: true,
                arrows: this.$slider.dataset.arrows !== "false" ? true : false,
                prevArrow: `<span class="carousel-arrow carousel-arrow--prev"><svg class="icon-svg icon-svg--outline"><use xlink:href="#icon-angle-left"></use></svg></span>`,
                nextArrow: `<span class="carousel-arrow carousel-arrow--next"><svg class="icon-svg icon-svg--outline"><use xlink:href="#icon-angle-right"></use></svg></span>`,
                pagination: !!this.$slider.dataset.pagination || false,
                controlsAppendTo: this.$slider.dataset.controlsAppendTo || null,
                appendArrows: this.$slider.dataset.arrowsAppendTo || this.$slider,
                autoplay: this.$slider.dataset.autoplay || false,
                autoplaySpeed: this.$slider.dataset.autoplaySpeed || 4000,
                adaptiveHeight: this.$slider.dataset.adaptiveHeight === "true" || false,
                rtl: isRtl
            }, options)

            if (this.$slider.dataset.autoplaySpeed) {
                this.$slider.style.setProperty('--autoplay-speed', `${this.$slider.dataset.autoplaySpeed}ms`);
            }
        }

        init() {
            this.initCallback()
            this.addClassModifiers()
            this.sliderEventsCallback()
            this.setSync()
            this.scrollToPanel()
            if (this.options.pagination) this.makePagination()
            if(this.syncLocation) this.syncSlideWithLocation()
            this.makeCarousel()
            if (this.options.pagination) this.paginationUpdate()
            this.addlisteners()

            this.$slider.getSlick = () => this
        }

        addClassModifiers() {
            if (this.arrowModifiers)
                this.updateOptions({
                    prevArrow: `<span class="carousel-arrow carousel-arrow--prev ${this.arrowModifiers}"><svg class="icon-svg icon-svg--outline"><use xlink:href="#icon-angle-left"></use></svg></span>`,
                    nextArrow: `<span class="carousel-arrow carousel-arrow--next ${this.arrowModifiers}"><svg class="icon-svg icon-svg--outline"><use xlink:href="#icon-angle-right"></use></svg></span>`,
                })
        }

        syncSlideWithLocation() {
            const windowHref = window.location.href
            const slides = gsap.utils.toArray(this.$slides)
            const index = slides.findIndex($slide => {
                const $link = $slide.querySelector('a[href]')
                if(!$link) return 0
                return windowHref.match($link.getAttribute('href'))
            })

            if(index !== -1) slides[index].classList.add('active-link')

            let slidesToShow = this.options.slidesToShow

            this.options.responsive.reverse().every(screen => {
                if(window.innerWidth < screen.breakpoint) {
                    slidesToShow = screen.settings.slidesToShow
                    return false
                }
                return true
            })

            if(this.$slides.length > slidesToShow) {
                this.updateOptions({
                    initialSlide: index === -1 ? 0 : index,
                    focusOnSelect: false
                })
            }
        }


        setSync() {
            if (this.asNavFor) {
                this.updateOptions({
                    asNavFor: this.asNavFor
                })
            }
        }

        updateOptions(options) {
            Object.assign(this.options, {
                ...options
            })
        }



        scrollToPanel() {

            if (this.goToPanel) {
                const $items = gsap.utils.toArray(this.$slides)
                $items.forEach($item => {
                    $item.addEventListener('click', () => {
                        gsap.to(window, {
                            duration: 1,
                            scrollTo: {
                                y: this.asNavFor,
                                offsetY: 100
                            },
                            ease: 'power2.inOut'
                        })
                    })
                })
            }
        }

        sliderEventsCallback() {
            // Lazyloading
            $(this.$slider).on('lazyLoaded', function (event, slick, image, imageSource) {
                image.parents('.slick-slide--lazyloading').removeClass('slick-slide--lazyloading')
                if (image.parent().hasClass('bg-img')) image.parent().addClass('bg-img--loaded')
            })

            // after change
            $(this.$slider).on('afterChange', (event, slick, currentSlide, nextSlide) => {
                if(this.options.pagination) this.paginationUpdate()
            })
        }

        initCallback() {
            return false
        }

        resizeCallback() {
            return false
        }

        unslick() {
            $(this.$slider).slick('unslick')
        }

        makeCarousel() {
            if (this.options.lazyLoad) {
                this.$slides.forEach($s => $s.classList.add('slick-slide--lazyloading'))
            }
            if (this.$slider.getSlick) this.unslick()
            $(this.$slider).slick(this.options)
           
        }

        makePagination() {
            this.$pagination = document.createElement('div')
            this.$pagination.classList.add('card-carousel__pagination')
            this.$pagination.innerHTML = `<div class="card-carousel__pagination-list"></div>`

            this.$slides.forEach(($s, index) => {
                this.$pagination.querySelector('.card-carousel__pagination-list').appendChild(this.paginationItem($s, index))
            })

            this.$slider.parentNode.appendChild(this.$pagination)

            if(this.options.controlsAppendTo === 'pagination') {
                this.updateOptions({
                    appendArrows: this.$pagination
                })
            }
        }

        paginationItem($slide, index) {
            const label = $slide.dataset.paginationLabel
            const $paginationItem = document.createElement('div')
            $paginationItem.classList.add('card-carousel__pagination-item')

            $paginationItem.innerHTML = `<span><span class="card-carousel__pagination-item__index">${String(index+1).padStart(2, '0')}.&nbsp;</span>${label}</span>`

            $paginationItem.addEventListener('click', () => {
                console.log(index)
                $(this.$slider).slick('slickGoTo', index, false)
            })

            return $paginationItem
        }

        paginationUpdate() {
            const currentIndex = $(this.$slider).slick('slickCurrentSlide')
            const $paginationItems = $(this.$pagination).find('.card-carousel__pagination-item')
            const $paginationList = $(this.$pagination).find('.card-carousel__pagination-list')
            $paginationItems.removeClass('card-carousel__pagination-item--active')
            const $activePaginationItem =  $paginationItems.eq(currentIndex)

            $activePaginationItem.addClass('card-carousel__pagination-item--active')

            gsap.to($paginationList, {duration: 0.4, scrollTo: {
                x: $activePaginationItem,
                offsetX: 15
            }})
        }

        // Video utilities
        pauseSlideVideo(currentSlide) {
            const $slide = this.$slides[currentSlide]
            if (!$($slide).find('.banner-video').length) return
                
            const $bannerVideo = $($slide).find('.banner-video')
            if($bannerVideo.length) $bannerVideo[0].getVideo()._pauseVideo()
        }

        playSlideVideo(currentSlide) {
            const $slide = this.$slides[currentSlide]
            if (!$($slide).find('.banner-video').length) return
            const $bannerVideo = $slide.querySelector('.banner-video[data-autoplay="1"]')
            $bannerVideo?.getVideo()._playVideo()
        }



        addlisteners() {
            $(this.$slider).on("beforeChange", (event, slick, currentSlide, nextSlide) => {
                if(this.options.pauseVideoOnCurrent === "1") this.pauseSlideVideo(currentSlide)
            })

            $(this.$slider).on("afterChange", (event, slick, currentSlide, nextSlide) => {
                if(this.options.pauseVideoOnCurrent === "1") this.playSlideVideo(currentSlide)
            })
            // Resize listener
            const resizeFunc = utilities.debounce(() => {
                this.isMobile = window.innerWidth < settings.breakpoints.mobile
                this.resizeCallback()
            }, 250)
            window.addEventListener('resize', resizeFunc)
        }
    }

    return {
        SlickCarousel
    }
})()